import { Directive, Input, OnChanges } from "@angular/core";
import {
  NG_VALIDATORS,
  UntypedFormControl,
  Validators,
  Validator
} from "@angular/forms";

@Directive({
  selector: "[uniqueUrl][ngModel]",
  providers: [
    { provide: NG_VALIDATORS, useExisting: UniqueUrlValidator, multi: true }
  ]
})
export class UniqueUrlValidator implements OnChanges, Validator {
  @Input("uniqueUrl")
  key: Array<string>;
  validatorFn: any = Validators.nullValidator;

  constructor() {
  }

  ngOnChanges(): void {
    if (this.key) {
      this.validatorFn = this.configureValidator(this.key);
    } else {
      this.validatorFn = Validators.nullValidator;
    }
  }

  configureValidator(forbiddenValues: Array<any>) {
    return currentValue => {
      let result = null;
      if(currentValue) {
        // any url that does not have a 
        // protocol gets http:// prepended
        if(!/^(f|ht)tps?:\/\//i.test(currentValue)){
          currentValue = `http://${currentValue}`;
        }
        result = forbiddenValues.some(value => value.trim().toLowerCase() === currentValue.trim().toLowerCase());
      }
      return result ? { uniqueUrl: "wrong" } : null;
    };
  }

  validate(control: UntypedFormControl) {
    return this.validatorFn(control.value);
  }
}
